import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapDisclaimerToSections } from 'utils/legal/sections';

const Disclaimer = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapDisclaimerToSections(t), [language]);
  const title = t('title', 'disclaimer') || 'Disclaimer';
  const lastUpdated = t('lastUpdated', 'disclaimer') || '';

  return <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />;
};

export default Disclaimer;
